import { canViewDirectory } from '../lib/entitlements';
import { useAuth } from '../context/AuthContext';
import SubscribeWall from './SubscribeWall';

export default function SubscriptionGate({
  children,
  directoryKey,
  feature = 'Directory access',
}) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="min-h-[45vh] bg-theme" aria-label="Loading subscriber access" />;
  }

  if (canViewDirectory(user, directoryKey)) return children;

  return (
    <div className="min-h-[60vh] bg-theme px-4 py-12 sm:px-6 lg:px-8" data-testid={'subscription-gate-' + directoryKey}>
      <div className="mx-auto max-w-3xl">
        <SubscribeWall
          title={feature + ' is for subscribers'}
          description="Join Pro or Premium to view this professional directory and unlock the deeper CCUK network. Industry Services stay public."
          feature={feature}
          testId={'subscribe-wall-' + directoryKey}
        />
      </div>
    </div>
  );
}
